module.exports = __webpack_public_path__ + "static/media/art36.d209d279.jpg";